// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  escortId: __t.u64().primaryKey().name("escort_id"),
  campaignId: __t.u64().name("campaign_id"),
  side: __t.u8(),
  cls: __t.string(),
  slot: __t.u32(),
  alive: __t.bool(),
  killedBy: __t.string().name("killed_by"),
  round: __t.u32(),
  killedAt: __t.timestamp().name("killed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
